import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { DescriptionBylineStyle } from './styles';
import { messages } from '../i18n';
var TeamMentionDescriptionByline = /*#__PURE__*/function (_React$PureComponent) {
  function TeamMentionDescriptionByline() {
    var _this;
    _classCallCheck(this, TeamMentionDescriptionByline);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TeamMentionDescriptionByline, [].concat(args));
    _defineProperty(_this, "renderByline", function (memberCount, includesYou) {
      if (includesYou) {
        if (memberCount > 50) {
          return _this.getBylineComponent( /*#__PURE__*/React.createElement(FormattedMessage, messages.plus50MembersWithYou));
        }
        return _this.getBylineComponent( /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.memberCountWithYou, {
          values: {
            0: memberCount
          }
        })));
      } else {
        if (memberCount > 50) {
          return _this.getBylineComponent( /*#__PURE__*/React.createElement(FormattedMessage, messages.plus50MembersWithoutYou));
        }
        return _this.getBylineComponent( /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.memberCountWithoutYou, {
          values: {
            0: memberCount
          }
        })));
      }
    });
    _defineProperty(_this, "getBylineComponent", function (message) {
      return /*#__PURE__*/React.createElement(DescriptionBylineStyle, null, message);
    });
    return _this;
  }
  _inherits(TeamMentionDescriptionByline, _React$PureComponent);
  return _createClass(TeamMentionDescriptionByline, [{
    key: "render",
    value: function render() {
      var context = this.props.mention.context;
      if (!context) {
        return null;
      }
      var includesYou = context.includesYou;
      var memberCount = context.memberCount;
      return this.renderByline(memberCount, includesYou);
    }
  }]);
}(React.PureComponent);
export { TeamMentionDescriptionByline as default };